import React from 'react';
import { Text } from 'src/modules/shared/components/atoms/text';

interface FormFieldProps {
  label: string;
  error?: string;
  required?: boolean;
  helpText?: string;
  children: React.ReactNode;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  error,
  required = false,
  helpText,
  children,
  className = '',
}) => {
  return (
    <div className={`space-y-2 ${className}`}>
      <div className="flex items-center gap-1">
        <Text as="label" size="small" weight="medium" className="text-gray-700">
          {label}
        </Text>
        {required && (
          <Text size="small" className="text-danger-500">
            *
          </Text>
        )}
      </div>

      {children}

      {helpText && (
        <Text size="tiny" className="text-gray-500">
          {helpText}
        </Text>
      )}

      {error && (
        <Text size="tiny" className="text-danger-500">
          {error}
        </Text>
      )}
    </div>
  );
};
